export default __webpack_public_path__ + "static/media/solo.80bb8cf2.png";